// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormPopupGetPriceEquipment
{
	#app;
	#appInstance = null;
	#productId = null; // Инициализация свойства для хранения id продукта
	constructor(rootNode, productId): void
	{
		this.rootNode = document.querySelector(rootNode);
		this.#productId = productId;
	}
	// Метод для установки id продукта
	setProductId(productId): void
	{
		this.#productId = productId;
		if (this.#appInstance)
		{
			this.#appInstance.productId = productId;
		}
	}

	start(): void
	{
		if (this.#appInstance)
		{
			this.#appInstance.productId = this.#productId;
			return;
		}
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form :product-id="productId"/>
				</div>
				`,
			data: () => ({
				productId: this.#productId // Передача id продукта в данные компонента
			}),
		});
		this.#appInstance = this.#app.mount(this.rootNode);
	}
}
